import { Star } from "lucide-react";

export default function TrustBanner() {
  return (
    <section
      data-testid="trust-banner"
      className="relative overflow-hidden py-24 md:py-32 bg-white"
    >
      {/* Floating decorative stars */}
      <div aria-hidden className="absolute inset-0 pointer-events-none">
        {[
          { top: "12%", left: "6%", size: 14, cls: "dA" },
          { top: "22%", right: "8%", size: 22, cls: "dB" },
          { top: "60%", left: "4%", size: 18, cls: "dC" },
          { bottom: "18%", right: "12%", size: 16, cls: "dD" },
          { top: "70%", right: "26%", size: 12, cls: "dE" },
          { bottom: "30%", left: "22%", size: 20, cls: "dF" },
        ].map((s, i) => (
          <Star
            key={i}
            size={s.size}
            className={`absolute float-star ${s.cls} text-[color:var(--maqam-gold)]`}
            style={{ top: s.top, left: s.left, right: s.right, bottom: s.bottom, fill: "currentColor" }}
          />
        ))}
      </div>

      <div className="relative max-w-5xl mx-auto px-5 md:px-8 text-center">
        <div
          data-testid="trust-google-pill"
          className="inline-flex items-center gap-2 rounded-full border border-[var(--maqam-border)] bg-white px-4 py-2 review-shadow"
        >
          <div className="flex items-center gap-0.5">
            {[0, 1, 2, 3, 4].map((i) => (
              <Star
                key={i}
                size={16}
                className={`text-[color:var(--maqam-gold)] star-pulse d${i}`}
                style={{ fill: "currentColor" }}
              />
            ))}
          </div>
          <span className="text-xs font-semibold tracking-[0.14em] uppercase text-[color:var(--maqam-navy)]">
            Google Reviews
          </span>
        </div>

        <h1
          data-testid="trust-banner-heading"
          className="mt-8 font-serif text-4xl sm:text-5xl md:text-6xl leading-[1.05] tracking-tight text-[color:var(--maqam-navy)]"
        >
          Trusted by Pilgrims Across Canada
          <br className="hidden md:block" />
          <span className="text-[color:var(--maqam-gold)]"> &amp; Around the World</span>
        </h1>

        <p className="mt-6 text-base md:text-lg text-[var(--maqam-muted)] leading-relaxed max-w-2xl mx-auto">
          Guiding pilgrims through one of the most important journeys of their lives.
        </p>

        <div className="mt-10 inline-flex items-center gap-3">
          <span className="gold-divider" />
          <span className="text-xs tracking-[0.24em] uppercase text-[color:var(--maqam-gold-2)]">
            Verified · Authentic · Real Pilgrims
          </span>
          <span className="gold-divider" />
        </div>
      </div>
    </section>
  );
}
